import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  listHeader: {
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  iconWrapper: {
    marginRight: '20px',
    '& .MuiSvgIcon-root path': {
      fill: palette.shades[500]
    }
  },
  success: {
    background: palette.success.gradient
  },
  info: {
    background: palette.info.gradient
  },
  warning: {
    background: palette.warning.gradient
  },
  error: {
    background: palette.error.gradient
  },
  actionButtons: {
    '& .MuiButton-root + .MuiButton-root': {
      marginLeft: '10px'
    }
  }
}));
export default useStyles;